import { render } from "./ConfigurationTemplate.vue?vue&type=template&id=7fa883fd&scoped=true"
import script from "./ConfigurationTemplate.vue?vue&type=script&lang=js"
export * from "./ConfigurationTemplate.vue?vue&type=script&lang=js"

import "./ConfigurationTemplate.vue?vue&type=style&index=0&id=7fa883fd&scoped=true&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa883fd"]])

export default __exports__